/* eslint-disable no-undef */
import { useMainStore } from '@/stores/store';
export default {
  install: () => {
    const mainStore = useMainStore();
    const {
      appMode
    } = storeToRefs(mainStore);
    const mode = process.env.NODE_ENV || 'development';
    // const mode = 'production';
    appMode.value = mode;
  }
};